<template src="~common/StickyHeader.html" />

<script>
  /**
   * TODO :
   * Make a shared components with the Devices page
   */
  import Helpers from '~plugins/Helpers'
  import  FiberOptions from "./FiberOptions.vue"
  import { mapGetters } from 'vuex'
	export default {
    props: {
      planDataFromMagento: {
        type: Object,
        default: () => undefined
      },
      traduction: {
        type: Function
      }
    },
    data () {
      return {
        addToCartButtonState: {
          tabindex: 1,
          disabled: false,
        },
        popOverPlacement: 'bottom',
        popOverInfosID: '',
        currentPopeOver: '',
        liveboxChecked: false,
        activeOptions: [],
        totalOptionsPrice: 0
      }
    },
    beforeMount() {
        const firstLoad = sessionStorage.getItem('firstLoad');
        const stickyPrices = this.planDataFromMagento.plan.sticky_prices;

// Retrieve current plan prices from localStorage
        const storedPlanPrices = localStorage.getItem('plan-prices');

        if (!firstLoad) {
            if (!storedPlanPrices || JSON.stringify(stickyPrices) !== storedPlanPrices) {
                // Update plan prices in localStorage if they are different or not present
                localStorage.setItem('plan-prices', JSON.stringify(stickyPrices));
            }
            sessionStorage.setItem('firstLoad', 'true');
        } else {
            sessionStorage.removeItem('firstLoad');
        }
        },
        mounted () {

      this.popOverPlacement = Helpers.isMobile() ? 'top' : 'bottom'

      document.addEventListener('scroll', function() {
        $('#popover-monthly').popover('hide');
        this.currentPopeOver = ''
      })

      this.popOverInfosID = Helpers.isMobile() ? '#popover-infos-mobile' : '#popover-infos-desktop'

      document.addEventListener('scroll', () => {
        $(this.popOverInfosID).popover('hide');
        this.currentPopeOver = ''
      })

        const liveBoxCheckbox = document.getElementById('livebox_prices');

        // Check if the checkbox exists before adding the listener
        if (liveBoxCheckbox) {
            liveBoxCheckbox.addEventListener('change', this.handleLiveBoxSwitchChange);
        }

      /**
       * Hide popover when the user click anywhere on the page
       */
      $('body').on('click', function (e) {
        //did not click a popover toggle, or icon in popover toggle, or popover
        if ($(e.target).data('toggle') !== 'popover'
            && $(e.target).parents('[data-toggle="popover"]').length === 0
            && $(e.target).parents('.popover.in').length === 0) {
            $('[data-toggle="popover"]').popover('hide');
        }
      })
    },
    beforeDestroy() {
        // Cleanup: Remove the event listener when the component is destroyed
        const liveBoxCheckbox = document.getElementById('livebox_prices');
        if (liveBoxCheckbox) {
            liveBoxCheckbox.removeEventListener('change', this.handleLiveBoxSwitchChange);
        }
    },
    watch: {
      currentPopeOver (value) {
        this.$nextTick(() => {
          const selector = '.' + this.currentPopeOver
          if (document && selector.length > 2 && document.querySelector(selector)) {
            document.querySelector(selector).innerHTML = this.popOverBodyContent
          }
        })
      },
      optionState:{
        handler: function (value) {
          this.getCurrentOptionState()
        },
        deep: true
      }
    },
    methods: {
      templateBasePopOver (className) {
        return `
          <div class="${ className }">
            ${ this.templatePopOver }
          </div>`
      },
        formatPrice(price) {
            if (isNaN(parseInt(price))) {
                return price
            }

            price = parseFloat(price);

            if (price % 1 === 0) {
              price = parseInt(price, 10);
            } else {
              price = price.toFixed(2);
            }

            const formattedPrice = this.planDataFromMagento.locale === 'en'
                ? price
                : price.toString().replace('.', ',');

            return this.planDataFromMagento.locale === 'en'
                ? `€${formattedPrice}`
                : `${formattedPrice}€`;
        },
        handleLiveBoxSwitchChange(event) {
            this.liveboxChecked = event.target.checked;
        },
        showLiveboxAdvantage() {
            if (!this.planDataFromMagento.plan.sticky_prices.subscription_convergent_discount || this.planDataFromMagento.plan.sticky_prices.subscription_convergent_discount.length === 0) {
                return false;
            }

            let queryParam = new URLSearchParams(window.location.search);
            if (+queryParam.get('livebox_prices')) {
                return true;
            } else if (queryParam.get('livebox_prices') == 0) {
                return false;
            }

            return localStorage.getItem('is_enable_livebox_for_plan') === '1';
        },
        getCurrentOptionState() {
          this.activeOptions = []
          this.optionState.length && this.optionState.forEach(item => {
              const key = Object.keys(item)[0];
              if (item[key].state === true) {
                  this.activeOptions.push(item[key])
              }
          });

          return this.optionState
        },
    },
		computed: {
        ...mapGetters({
            currentStep: 'GET_CURRENT_STEP',
            optionState: 'GET_OPTION_STATE'
        }),
      $t () {
        return this.traduction
      },
      stickyName () {
        return 'plan'
      },
        priceWithLiveboxAdvantage() {
            const stickyPrices = this.planDataFromMagento.plan.sticky_prices;

            const timeForPromo = stickyPrices.plan_promo_subscription_duration && stickyPrices.timezone_config;
            const monthlyPromoPrice = parseFloat(stickyPrices.plan_promo_price_with_discount ?? 0);
            const convergentDiscount = parseFloat(stickyPrices.subscription_convergent_discount);
            const regularPrice = parseFloat(stickyPrices.plan_monthly_price);
            const phoneInstallment = parseFloat(stickyPrices.phone_monthly_price ?? 0);

            // Determine the price with the convergent discount applied
            const priceWithDiscountLivebox = timeForPromo
                ? (monthlyPromoPrice >= convergentDiscount ? monthlyPromoPrice - convergentDiscount : monthlyPromoPrice)
                : (regularPrice >= convergentDiscount ? regularPrice - convergentDiscount : regularPrice);

            // Add phone installment if applicable
            const totalPrice = phoneInstallment > 0 ? priceWithDiscountLivebox + phoneInstallment : priceWithDiscountLivebox;

            // Ensure the price is non-negative and properly formatted
            return this.formatPrice(Math.max(0, totalPrice));
        },
            templatePopOver () {
        const instalment_duration = '24'
        const instalment_amount = this.planDataFromMagento.plan.sticky_prices.phone_monthly_price
          const relatedProducts = this.planDataFromMagento.plan.related_products
          let relatedProductNames = '';
          let relatedProductSubsPrices = '';
        const currency = '€'
          let liveboxDiscountPrice = this.planDataFromMagento.plan.sticky_prices.subscription_convergent_discount;
          const locale = this.planDataFromMagento.locale

          const timeForPromo = this.planDataFromMagento.plan.sticky_prices.plan_promo_subscription_duration && this.planDataFromMagento.plan.sticky_prices.timezone_config
          const monthlyPromoPrice = this.planDataFromMagento.plan.sticky_prices.plan_promo_price_with_discount ?? ''

          let monthly_price_formatted = timeForPromo ? this.formatPrice(Math.max(0, monthlyPromoPrice)) : this.formatPrice(this.planDataFromMagento.plan.sticky_prices.plan_monthly_price)
          let old_price_month_formatted = this.planDataFromMagento.plan.sticky_prices.old_price_plan

          let span_promo_space
          let span_promo
          let promo_price_text = this.planDataFromMagento.plan.sticky_prices.plan_promo_subscription_duration
          let text_with_discount_for_promo
          if (promo_price_text !== '1') {
              text_with_discount_for_promo = `${this.$t('for %1 month, then <br/>%2/month').replace('%1', promo_price_text).replace('%2', old_price_month_formatted)}`
          } else {
              text_with_discount_for_promo = `${this.$t('for %1 month, then <br/>%2/month').replace('%1', promo_price_text).replace('%2', old_price_month_formatted)}`
          }
          span_promo_space = this.planDataFromMagento.plan.sticky_prices.plan_promo_subscription_duration && this.planDataFromMagento.plan.sticky_prices.timezone_config ? '<span class="u-flex u-flex-column u-marg-t-md"></span>' : '';
          span_promo = this.planDataFromMagento.plan.sticky_prices.plan_promo_subscription_duration && this.planDataFromMagento.plan.sticky_prices.timezone_config ? '<span class="u-flex u-flex-column c-pricing__muted-text u-weight-normal u-grey-600 u-inline-block u-marg-b-xxxs">'+ text_with_discount_for_promo +'</span>' : '';

          const liveBoxCheckbox = document.getElementById('livebox_prices');
          const liveBoxDisplayCondition = liveBoxCheckbox ? this.liveboxChecked : this.showLiveboxAdvantage();
          const liveboxAdvantageSpan = liveBoxDisplayCondition ? `<span class="t-text--small u-white u-marg-t-xxs">${this.$t('Livebox advantage')}</span>` : '';
          const liveboxDiscountSpan = liveBoxDisplayCondition ? `<span class="t-text--small u-orange u-marg-t-xxs">-${this.formatPrice(liveboxDiscountPrice)}${this.$t('/month')}</span>` : '';

          if (relatedProducts.length > 0) {
              relatedProducts.forEach(relatedProduct => {
                  // Skip Livebox Modem because added as option
                  if (relatedProduct.sku === "LiveboxModem") {
                      return;
                  }

                  const relatedProductName = `<span class="u-white u-marg-t-xxs">${this.$t(relatedProduct.name)}</span>`
                  const relatedProductSubscriptionPrice = `<span class="u-orange u-marg-t-xxs">${this.formatPrice(relatedProduct.subscription_price)}${this.$t('/month')}</span>`

                  relatedProductNames += relatedProductName;
                  relatedProductSubsPrices += relatedProductSubscriptionPrice;
              });
          }

          let activeOptions = this.activeOptions ? this.activeOptions.map(e => {
            return { name: `<span class="u-white u-marg-t-xxs">${this.$t(e.option.name)}</span>`,
                     price: `<span class="u-orange u-marg-t-xxs">${this.formatPrice(e.option.price)}${this.$t('/month')}</span>`}
          }) : ''

          this.totalOptionsPrice = 0
          this.activeOptions.forEach(e => {
            this.totalOptionsPrice += +e.option.price
          })

          if (instalment_duration && instalment_amount) {
              if (this.planDataFromMagento.plan.sticky_prices.device_plan_engagement_duration == 0 && this.planDataFromMagento.plan.sticky_prices.instalment_amount == 0 && this.planDataFromMagento.plan.sticky_prices.instalment_duration == 0) {
                  return `
          <div class="u-flex u-flex-justify-between">
            <div class="u-flex u-flex-column">
              <span class="u-white u-marg-b-xxs">${this.planDataFromMagento.plan.name}</span>
              ${liveboxAdvantageSpan}
              <span class="u-white">${this.$t('Instalment')}</span>
            </div>
             <div class="u-flex u-flex-column u-marg-l-xxs u-right">
               <span class="u-orange u-marg-b-xxs">${monthly_price_formatted}/${this.$t('month')}</span>
               ${liveboxDiscountSpan}
              <span class="u-orange">-</span>
            </div>
          </div>
        `
              } else {
              let instalmentAmount = locale === 'en' ? `${this.$t('%1/month').replace('%1', `${currency}${instalment_amount}`)}</br>${this.$t('for %2 month').replace('%2', instalment_duration)}` : `${this.$t('%1/month').replace('%1', `${instalment_amount}${currency}`)}</br>${this.$t('for %2 month').replace('%2', instalment_duration)}`

          return `
            <div class="u-flex u-flex-justify-between">
              <div class="u-flex u-flex-column">
                <span class="u-white">${this.planDataFromMagento.plan.name}</span>
                 ${span_promo_space}
                 ${liveboxAdvantageSpan}
                <span class="u-white u-marg-t-xxs">${this.$t('Instalment')}</span>
              </div>
              <div class="u-flex u-flex-column u-marg-l-xxs u-right">
                <span class="u-orange">${monthly_price_formatted}/${this.$t('month')}</span>
                ${span_promo}
                ${liveboxDiscountSpan}
                <span class="u-orange u-marg-t-xxs">${instalmentAmount}</span>
              </div>
            </div>
          `
              }
        } else {
          return `
            <div class="u-flex u-flex-justify-between">
              <div class="u-flex u-flex-column">
                <span class="u-white">${this.planDataFromMagento.plan.name}</span>
                ${span_promo_space}
                ${liveboxAdvantageSpan}
                ${relatedProductNames}
                ${activeOptions.map(e => e.name).join('')}
              </div>
              <div class="u-flex u-flex-column justify-content-between u-marg-l-xxs u-right">
                <span class="u-orange">${monthly_price_formatted}/${this.$t('month')}</span>
                ${span_promo}
                ${liveboxDiscountSpan}
                ${relatedProductSubsPrices}
                ${activeOptions.map(e => e.price).join('')}
              </div>
            </div>
          `
        }
      },
      mobilePrice () {
          // const isFiberPlan = this.planDataFromMagento.plan.categorization === "fibre"
          // const installation = this.planDataFromMagento.plan.installation
          // const instalmentAmount = parseFloat(this.planDataFromMagento.plan.sticky_prices.instalment_amount)
          //
          // // currentStep 2 until Options step is hidden else step 3
          // if (isFiberPlan && this.currentStep === 2) {
          //     let totalInstallationPrice = 0;
          //
          //     if (installation) {
          //         for (let key in installation) {
          //             if (installation.hasOwnProperty(key) && key.startsWith('installation_')) {
          //                 let currentInstallation = installation[key];
          //
          //                 // Ensure currentInstallation is valid and its properties are numbers
          //                 if (currentInstallation && (currentInstallation.installation_price_promo || currentInstallation.installation_price)) {
          //                     let promoPrice = parseFloat(currentInstallation.installation_price_promo);
          //                     let regularPrice = parseFloat(currentInstallation.installation_price);
          //
          //                     if (!isNaN(promoPrice)) {
          //                         totalInstallationPrice += promoPrice;
          //                     } else if (!isNaN(regularPrice)) {
          //                         totalInstallationPrice += regularPrice;
          //                     }
          //                 }
          //             }
          //         }
          //     }
          //
          //     let finalPrice = instalmentAmount + totalInstallationPrice;
          //     return this.formatPrice(finalPrice);
          // }

        if (this.planDataFromMagento && this.planDataFromMagento.plan.sticky_prices.price && this.planDataFromMagento.plan.sticky_prices.price.length > 0) {
          return this.planDataFromMagento.plan.sticky_prices.price.replace(/\s/g, '')
        } else {
            return this.formatPrice(0)
        }
      },
      monthlyPrice () {
        if (this.planDataFromMagento && this.planDataFromMagento.plan.sticky_prices.monthly_price && this.planDataFromMagento.plan.sticky_prices.monthly_price.length > 0) {
            if (this.showLiveboxAdvantage()) {
                return this.priceWithLiveboxAdvantage
            } else {
                let monthlyPrice = this.planDataFromMagento.plan.sticky_prices.plan_monthly_price
                const isFiberPlan = this.planDataFromMagento.plan.categorization === "fibre"
                let instalment_amount = this.planDataFromMagento.plan.sticky_prices.phone_monthly_price ? parseFloat(this.planDataFromMagento.plan.sticky_prices.phone_monthly_price) : 0
                const relatedProducts = this.planDataFromMagento.plan.related_products

                const timeForPromo = this.planDataFromMagento.plan.sticky_prices.plan_promo_subscription_duration && this.planDataFromMagento.plan.sticky_prices.timezone_config
                const monthlyPromoPrice = this.planDataFromMagento.plan.sticky_prices.plan_promo_price_with_discount ?? ''

                let finalPrice = timeForPromo ? parseFloat(monthlyPromoPrice) : parseFloat(monthlyPrice);

                if (isFiberPlan && relatedProducts.length > 0) {
                    let relatedProductsSubsPrice = 0;

                    relatedProducts.forEach(relatedProduct => {
                        // Skip Livebox Modem because added as option
                        if (relatedProduct.sku === "LiveboxModem") {
                            return;
                        }

                        relatedProductsSubsPrice += parseFloat(relatedProduct.subscription_price || 0);
                    });

                    finalPrice += relatedProductsSubsPrice;
                }

                if (instalment_amount) {
                    finalPrice += instalment_amount;
                }

                return this.formatPrice(Math.max(0, finalPrice + this.totalOptionsPrice)) || this.planDataFromMagento.plan.sticky_prices.monthly_price.replace(/\s/g, '');
            }
        } else {
          return this.formatPrice(0)
        }
      },
       /**
       *
       * If the user select any other option and the mobilePrice is equal to zero the activation fees is equal to 5€
       * because the user can't continue if is cart contain zero €
       *
       * If the user select any other option and the mobilePrice is greater than zero then the shipping and the activations fees are equal to zero €
      */
      stickyLittleText () {
        if (this.planDataFromMagento && this.planDataFromMagento.plan.sticky_prices && this.planDataFromMagento.plan.sticky_prices.price) {

            let price_activation_lang = ''
            if (this.planDataFromMagento.locale === 'en') {
                price_activation_lang = parseInt(this.planDataFromMagento.plan.sticky_prices.price.substring(1));
            } else {
                price_activation_lang = parseInt(this.planDataFromMagento.plan.sticky_prices.price);
            }

          if (price_activation_lang === 5) {
            return `${this.$t('Activation fees')} ${this.planDataFromMagento.plan.sticky_prices.price.replace(/\s/g, '')}`
          } else if (price_activation_lang > 0){
            return this.$t('No shipping or activation fees')
          }
        }
      },

    }
  }
</script>
